import React from 'react';
import { connect } from 'react-redux';
import { Link as v4Link } from 'react-router-dom';

import { AppLayoutContainer } from '@zg-rentals/zrm-utils-js';
import { logout } from '../../../actions/userActions';
import { PROXY_PATH } from '../../../constants/endpoints';

function Container({ children, ...props }) {
  return <AppLayoutContainer {...props}>{children}</AppLayoutContainer>;
}

function mapStateToProps(state) {
  return {
    brand: 'zillow',
    userModel: state.user,
    altLogo: !state.user.isRocketshipCustomerOnly,
    csrf_token: state.app.csrfToken,
    displayAnalytics: state.user.canAccessMainAnalytics,
    proxyPath: `/${PROXY_PATH.substr(0, PROXY_PATH.length - 1)}`,
    reactRouterLink: v4Link,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleLogoutClick() {
      return dispatch(logout());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Container);
